import {createSelector} from 'reselect'
import type {RootState} from 'services/store'

export const rootDocumentsSelector = (state: RootState) => state.documents
export const documentsStatusSelector = createSelector(
  [rootDocumentsSelector],
  documents => documents.status
)
export const documentsSelector = createSelector(
  [rootDocumentsSelector],
  documents => documents.data
)
